import { createMemo } from "solid-js"
import { samePosition } from "../../lib/core/tile_position_xy/samePosition"
import { useHoveredPositionSignal } from "../signal/useHoveredPositionSignal"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { createSharedTileGraphNodeCollectionMemo } from "./createSharedTileGraphNodeCollectionMemo"
import useGridWidthHeight from "./useGridWidthHeight"

export const useHoveredTileGraphNodeMemo = createSharedCachedFactory((engine) => {
  const getGridSize = useGridWidthHeight(engine)
  const [getHoveredPosition] = useHoveredPositionSignal(engine)
  const getTileGraphNodesList = createSharedTileGraphNodeCollectionMemo(engine)

  const memo = createMemo(() => {
    const hoveredPosition = getHoveredPosition()
    if (hoveredPosition) {
      const { width: gridWidth } = getGridSize()
      const tileGraphNodeList = getTileGraphNodesList()
      const tileGraphNode = tileGraphNodeList[hoveredPosition.x + hoveredPosition.y * gridWidth]
      if (samePosition(hoveredPosition, tileGraphNode)) {
        return tileGraphNode
      }
    }
    return null
  })

  return memo
})
